import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, Input, Radio, Select, Tree, Steps, Button, Table, Alert } from 'antd'

import * as actions from './actions'
import * as p from '../../../actions/permissions'
import * as _ from 'lodash'
import { EditSelect } from '../../../components/table'
import { isAlphaNumUnderscore } from '../../../functions'


export class NewDatasourceDialog extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            canOk: false,
            rowSelection: [],
            importType: undefined,
            tableName: undefined,
            tableType: 'predictiveAnalytics',
        }
    }
    save = (e) => {
        e.preventDefault();
        var colTypes = this.state.columnTypes
        var rows = _.toArray(this.props.fileDetails)
        var selectedRows = this.state.selectedRows
        _.map(colTypes, (type, col) => {
            const indexRows = rows.findIndex((row => row.name === col))
            if (indexRows) {
                rows[indexRows].type = type
            }
            const selectedIndex = selectedRows.findIndex((row => row.name === col))
            if (selectedIndex) {
                selectedRows[selectedIndex].type = type
            }

        })
        if (this.state.importType === "storage") {
            let fileLocation = this.state.selectedFile
            if (this.state.bucket) {
                fileLocation = "gs://" + this.state.bucket + "/" + this.state.selectedFile
            }

            this.props.createLinkedDatasoureFromBucketFile(this.props.user._links[p.DATASOURCES].href, this.state.name, fileLocation, rows, selectedRows)
            this.setState({
                waiting: true
            })
        }

        else if (this.state.importType === "bigQuery") {
            this.props.createBigQueryDatasoure(this.props.user._links[p.DATASOURCES].href, this.state.name, this.state.tableName, this.state.tableType)
            this.setState({
                waiting: true
            })
        }


    }

    cancel = (e) => {
        this.clearState()
        this.props.onCancelComplete()

    }
    changeCreationProcess = (e) => {
        const { value } = e.target
        if (value === 'storage') {
            // get the list of buckets
            this.props.getBuckets(this.props.user._links[p.IMPORTS].href)
            this.setState({
                currentStep: 0
            })
        }

        this.setState({
            importType: value
        })
    }

    selectBucket = (name) => {
        this.props.getBucketFiles(`${this.props.user._links[p.IMPORTS].href}/${name}`)
        this.setState({
            bucket: name,
            files: [],
            selectedFile: undefined
        })

    }

    selectFile = (location, event) => {
        this.setState({
            selectedFile: event.node.props.value,
            selectedFileLocation: location
        })

    }

    nextStep() {
        const currentStep = this.state.currentStep + 1;
        if (currentStep === 1) {
            // load file definition
            this.props.getFileDefinition(this.state.selectedFileLocation)
        }
        this.setState({ currentStep: currentStep });
    }

    prevStep() {
        const currentStep = this.state.currentStep - 1;
        this.setState({ currentStep: currentStep });
    }

    clearState() {
        this.setState({
            currentStep: 0,
            selectedFileLocation: undefined,
            bucket: undefined,
            files: [],
            name: undefined,
            canOk: false,
            importType: undefined,
            allClear: true,
            fileDetails: undefined,
            tableName: undefined,
        });
    }

    updateColumnType(value, more) {

        var columnTypes = this.state.columnTypes || {}
        columnTypes[value.name] = more.name
        this.setState({ columnTypes: columnTypes })
        // update the state with the new column type

    }

    render() {
        const RadioGroup = Radio.Group
        const { Option } = Select
        const { TreeNode } = Tree
        const { Step } = Steps
        const { Column } = Table

        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        }

        const buckets = () => {
            if (this.props.buckets) {
                return _.map(this.props.buckets, bucket => <Option key={bucket.id} value={bucket.id}>{bucket.name}</Option>)
            }
        }

        const files = () => {
            if (this.props.files && this.state.bucket) {
                return _.map(this.props.files, file => {
                    return (<TreeNode key={file.definition} value={file.name}
                        title={file.name + ' (' + file.length + ')'}
                    />)
                })
            }
            return null
        }

        const nameChanged = (e) => {
            this.setState({
                name: e.target.value
            })

        }
        const tableNameChanged = (e) => {
            if (isAlphaNumUnderscore(e.target.value)) {
                this.setState({
                    tableName: e.target.value
                })
            }

        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRows
                })
            },
            onSelect: (record, selected, selectedRows) => {
                this.setState({
                    selectedRows
                })
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                this.setState({
                    selectedRows
                })
            },
        }
        const currentStep = this.state.currentStep
        if (this.props.importCompleted === true && this.state.waiting === true) {
            this.setState({
                waiting: false,
            })
            this.clearState()

            this.props.onSaveComplete()
        }

        const showSpinner = (this.props.alertMessage && this.state.importType !== undefined)
        const okButtonDisabled = ((this.state.importType === 'bigQuery' && (this.state.name === undefined || this.state.tableName === undefined)) ||
            (this.state.importType === 'storage' && (this.state.selectedRows === undefined || this.state.selectedRows.length === 0 || this.state.name === undefined || this.state.name === '')))

        return (
            <Modal
                {...this.props}
                onOk={this.save}
                onCancel={this.cancel}
                okButtonProps={{
                    disabled: (okButtonDisabled)
                }}
            >
                <div className="spin-block"
                    style={{ visibility: showSpinner ? '' : 'hidden' }}
                >
                    <Alert
                        message="Please wait"
                        description={this.props.alertMessage || 'Nothing to see'}
                        type="info"
                        showIcon={true}
                        iconType={"loading"}
                    />
                </div>

                <Input
                    addonBefore='Name'
                    label='Name'
                    value={this.state.name}
                    onChange={nameChanged}
                />
                <RadioGroup onChange={this.changeCreationProcess} value={this.state.importType}>
                    <Radio style={radioStyle} value={'bigQuery'}>Google BigQuery table</Radio>
                    <Radio style={radioStyle} value={'storage'}>Create a new linked Google Storage datasource</Radio>
                </RadioGroup>
                <div style={
                    {
                        display: (this.state.importType === 'bigQuery') ? '' : 'none',

                    }} >
                    <br />
                    <Input
                        addonBefore='Table name'
                        label='Table name'
                        value={this.state.tableName}
                        onChange={tableNameChanged}
                    />
                    <p>Table name consists of letters (upper and lowercase), numbers and underscores only.</p>
                    <br />
                    <p>Dataset definition</p>
                    <RadioGroup value={this.state.tableType}>
                        <Radio style={radioStyle} value={'predictiveAnalytics'}>Preditive analytics template</Radio>
                        <Radio style={radioStyle} disabled value={'custom'}>Custom dataset format</Radio>
                    </RadioGroup>

                </div>
                <div style={
                    {
                        visibility: (this.state.importType === 'storage') ? '' : 'hidden',

                    }} >
                    <br />
                    <div style={{
                        padding: '10px',
                    }}>
                        <Steps current={this.state.currentStep}>

                            <Step
                                style={{ whiteSpace: 'normal' }}
                                title="File selection"
                                description="Select a file from a Google storage bucket"
                                key="1">
                            </Step>
                            <Step
                                style={{ whiteSpace: 'normal' }}
                                title="Field selector"
                                description="Configure the fields to be imported"
                                key="2">
                            </Step>
                        </Steps>
                    </div>
                    <div style={{
                        visibility: currentStep === 0 ? '' : 'hidden',
                        height: currentStep === 0 ? '' : '0',
                    }} >
                        <br />
                        <p>Select a Google storage bucket</p>
                        <Select
                            onChange={this.selectBucket}
                            notFoundContent="...loading..."
                            value={this.state.bucket}
                            style={{
                                display: 'inherit'
                            }}
                        >
                            {buckets()}
                        </Select>
                        <br />
                        <div style={{
                            overflowY: 'scroll',
                            maxHeight: '300px'
                        }}>
                            <Tree
                                onSelect={this.selectFile}
                                value={this.state.selectedFile}
                            >
                                {files()}
                            </Tree>
                        </div>
                        <br />

                    </div>
                    <div style={{
                        visibility: currentStep === 1 ? '' : 'hidden',
                        height: currentStep === 1 ? '' : '0',
                    }} >
                        <br />
                        <p>Please select the fields that you would like to be part of the new datasource</p>
                        <div style={{
                            overflowY: 'scroll',
                            maxHeight: '400px',
                            padding: '10px',
                        }}>
                            {this.props.fileDetails ? (

                                <Table
                                    rowSelection={rowSelection}
                                    dataSource={_.toArray(this.props.fileDetails)}
                                    pagination={false}
                                >
                                    <Column title='Column name'
                                        dataIndex='name'
                                        key='name'
                                    />

                                    <Column title='Data type'
                                        dataIndex='type'
                                        key='type'
                                        render={(text, record, index) => (
                                            <EditSelect
                                                onChange={value => (
                                                    this.updateColumnType(record, { name: value, description: record }))
                                                }
                                                value={text}
                                                values={[{ value: "string", label: "String" }, { value: "integer", label: "Integer" }, { value: "real", label: "Float" }]}
                                                mkey={"type." + index}
                                            />
                                        )}
                                    />
                                </Table>
                            ) : (<div>... loading file column information ... </div>)
                            }
                        </div>
                    </div>

                    <div className="steps-action">
                        {
                            currentStep < 1
                            && <Button disabled={(this.state.selectedFile === undefined || this.state.name === undefined || this.state.name === '')} type="primary" onClick={() => this.nextStep()}>Next</Button>
                        }
                        {
                            currentStep > 0
                            && (
                                <Button style={{ marginLeft: 8 }} onClick={() => this.prevStep()}>Previous</Button>
                            )
                        }
                    </div>
                </div>
            </Modal>)

    }
}



NewDatasourceDialog = connect(
    (state, props) => ({
        ...state.datasources,
        fileDetails: state.datasources.fileDetails ? state.datasources.fileDetails.properties : undefined,
        user: state.user.profile,
    }),
    dispatch => (
        bindActionCreators(actions, dispatch)
    )
)(NewDatasourceDialog)




// WEBPACK FOOTER //
// ./src/App/Admin/Datasources/NewDatasourceDialog.jsx